import { useLostCargoReturnPage } from '../context/LostCargoReturnPageContext';
import { useTranslation } from 'react-i18next';
import LostCargoCustomGrid from './LostCargoCustomGrid';
import { Card, Chip, Divider } from '@mui/material';
import '../components/LostCargo.scss'
import LostCargoInfoCard from './LostCargoInfoCard';
import { LCSR, lcsrCls } from '../lostCargoSearchReturnPage.classes';

function LostCargoSearchProductList() {
  const { returnListData } = useLostCargoReturnPage();
  const { t } = useTranslation();

  return (
    <div>
      {returnListData.shippingListForBackofficeModels && returnListData.shippingListForBackofficeModels.length > 0 ? (
        <>
          <Card className={lcsrCls('infoContainer', LCSR.summaryCard)}>
            <div className={LCSR.summaryCardHeader} style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
              <h3 className={LCSR.summaryCardTitle} style={{ marginLeft: "0.5rem" }}>
                <strong> {t("lostCargoReturnPageBuilder.lostCargoReturnPage")}</strong>
              </h3>
              <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                <a className={LCSR.linkTrackingCarrier} href={returnListData?.shippingListForBackofficeModels[0]?.trackingNumber} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                  <Chip
                    className={LCSR.summaryCarrierChip}
                    label={returnListData?.shippingListForBackofficeModels[0]?.shippingCompanyName}
                    color="success"
                  />
                </a>
                <Chip
                  className={LCSR.summaryStatusChip}
                  label={returnListData?.shippingListForBackofficeModels[0]?.shippingListStatusDecription}
                  color="warning"
                />
              </div>
            </div>
            <Divider />
            <LostCargoInfoCard />
          </Card>
          <LostCargoCustomGrid />
        </>) : (
        <div className={LCSR.emptyListMessage}>{t('general.noDataFound')}</div>
      )}
    </div>
  )
}

export default LostCargoSearchProductList;